var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNibirulogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 153,
    height: 234,
    viewBox: "0 0 153 234",
    fill: "black",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5278 0L0.528447 55.173L153.166 165.338V51.4368L79.5278 0ZM138.708 136.542L26.2388 55.3746L79.7932 17.97L138.708 59.1109V136.542Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 68.6536V182.619L75.5388 233.992L152.511 178.734L0 68.6536ZM14.9995 174.818V97.4501L127.543 178.724L75.5812 216.022L14.9995 174.818Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10615_7221",
    x1: -86.5619,
    y1: -25.198,
    x2: 937.771,
    y2: 193.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F2A9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#F2BAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#CDC6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#82D1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#09D4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#11BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10615_7221",
    x1: -86.5619,
    y1: -25.198,
    x2: 937.771,
    y2: 193.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F2A9CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#F2BAD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395,
    stopColor: "#CDC6D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#82D1D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#09D4D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#11BBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17A0BF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNibirulogo);
export default __webpack_public_path__ + "static/media/Nibirulogo.9ff786f3a66a063ab830cb19e1de77e0.svg";
export { ForwardRef as ReactComponent };